import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting';
import { fetchUserDataById } from '../../services2/users.service';

const groupADetails=`
<table border="1" cellspacing="0" cellpadding="5">
<tr>
<th style="border: 1px solid black;">任務</th>
<th style="border: 1px solid black;">數量</th>
<th style="border: 1px solid black;">建議完成時間</th>
</tr>
<tr>
<td style="border: 1px solid black;">問卷第一部分</td>
<td style="border: 1px solid black;">7組</td>
<td style="border: 1px solid black;">10分鐘</td>
</tr>
<tr>
<td style="border: 1px solid black;">短篇閱讀題</td>
<td style="border: 1px solid black;">6道題</td>
<td style="border: 1px solid black;">5分鐘</td>
</tr>
<tr>
<td style="border: 1px solid black;">閱讀測試</td>
<td style="border: 1px solid black;">閱讀任務一、二：共21題</td>
<td style="border: 1px solid black;">30分鐘</td>
</tr>
<tr>
<td style="border: 1px solid black;">問卷第二部分</td>
<td style="border: 1px solid black;">6組</td>
<td style="border: 1px solid black;">10分鐘</td>
</tr>
</table>
`
const groupBDetails=`
<table border="1" cellspacing="0" cellpadding="5">
<tr>
<th style="border: 1px solid black;">任務</th>
<th style="border: 1px solid black;">數量</th>
<th style="border: 1px solid black;">建議完成時間</th>
</tr>
<tr>
<td style="border: 1px solid black;">問卷第一部分</td>
<td style="border: 1px solid black;">8組</td>
<td style="border: 1px solid black;">10分鐘</td>
</tr>
<tr>
<td style="border: 1px solid black;">短篇閱讀題</td>
<td style="border: 1px solid black;">6道題</td>
<td style="border: 1px solid black;">5分鐘</td>
</tr>
<tr>
<td style="border: 1px solid black;">閱讀測試</td>
<td style="border: 1px solid black;">閱讀任務一、二：共21題</td>
<td style="border: 1px solid black;">30分鐘</td>
</tr>
<tr>
<td style="border: 1px solid black;">問卷第二部分</td>
<td style="border: 1px solid black;">6組</td>
<td style="border: 1px solid black;">10分鐘</td>
</tr>
</table>
`


const RESEARCHES = [
//     {
//         id: '100',
//         name: 'Pilot Test',
//         image: '/secondary/tasks/11.png',
//         subtitle: '研究測試 Pilot Test',
//         link: '/platform2/research-practices/preview/100',
//         description: `
// <b>閱讀測試說明</b><br/>
// • 本次測試共分為四部分：<b>問卷一、短篇閱讀、閱讀測試（篇章一及篇章二）及問卷二。</b> <br/>
// • 總建議完成時間為 <b>55分鐘</b>。 <br/>
// • 請仔細閱讀材料，並按題目要求作答。 <br/>
// • 所有題目均須作答。 <br/>
// • 完成後請檢查答案。<br/>
// `,
//     },
    {
        id: '1001',
       name: '前測',
        image: '/secondary/tasks/11.png',
        subtitle: '研究測試-前測',
        link: '/platform2/research-practices/preview/1001',
        description: `
<b>閱讀測試說明</b><br/>
• 本次測試共分為四部分：<b>問卷一、短篇閱讀、閱讀測試（篇章一及篇章二）及問卷二。</b> <br/>
• 總建議完成時間為 <b>55分鐘</b>。 <br/>
• 請仔細閱讀材料，並按題目要求作答。 <br/>
• 所有題目均須作答。 <br/>
• 完成後請檢查答案。<br/>
`,
    },
    {
        id: '1002',
        name: '中測',
        image: '/secondary/tasks/11.png',
        subtitle: '研究測試-中測',
        link: '/platform2/research-practices/preview/1002',
        description: `
<b>閱讀測試說明</b><br/>
• 本次測試共分為四部分：<b>問卷一、短篇閱讀、閱讀測試（篇章一及篇章二）及問卷二。</b> <br/>
• 總建議完成時間為 <b>55分鐘</b>。 <br/>
• 請仔細閱讀材料，並按題目要求作答。 <br/>
• 所有題目均須作答。 <br/>
• 完成後請檢查答案。<br/>
`,
    },
    {
        id: '1003',
        name: '後測',
        image: '/secondary/tasks/11.png',
        subtitle: '研究測試-後測',
        link: '/platform2/research-practices/preview/1003',
        description: `
<b>閱讀測試說明</b><br/>
• 本次測試共分為四部分：<b>問卷一、短篇閱讀、閱讀測試（篇章一及篇章二）及問卷二。</b> <br/>
• 總建議完成時間為 <b>55分鐘</b>。 <br/>
• 請仔細閱讀材料，並按題目要求作答。 <br/>
• 所有題目均須作答。 <br/>
• 完成後請檢查答案。<br/>
`,
    },

]



function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(RESEARCHES.filter(item => item.id === id)?.[0])
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();

    const [group, setGroup] = useState('1')
    const [user, setuser] = useState(null)
    // const [school, setSchool] = useState(null)

    async function fetchGroupData() {
        let result = await fetchUserDataById(props.token.token)
        if (result.result) {
            setuser(result.result)
            if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'].includes(result.result.group)) {
                setGroup(result.result.group)
                console.log('Group set to ' + result.result.group)
            }

        }
    }
    useEffect(() => {
        if (props.token.token)
            fetchGroupData()
    }, [props.token.token])


    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        // let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        // if (result.result) {
        //     setdata(result.result)
        //     settotal(result.count || 0)
        // } else {
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }



    useEffect(() => {
        fetchData(true)
    }, [])



    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px] overflow-auto' style={{ fontSize, backgroundImage: `url('/secondary/bg7.png')`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px] p-[16px]'>
                <div className='text-[#4B555C] font-[700] cursor-pointer' style={{ fontSize: fontSize + 4 }} onClick={() => { navigate('/platform2/research-practices') }}>{'< 返回 全部研究測試'}</div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-col w-full flex-wrap justify-between items-stretch font-[600]'>
                <img src={data?.image} alt={data?.name} className='w-full h-auto max-h-[50vh]' style={{ objectFit: 'cover' }} />
                <div className='p-[16px] flex flex-col gap-[8px]'>
                    <div className='text-[#4B555C] font-[900]' style={{ fontSize: fontSize + 4 }}>{data?.name}</div>
                    <div className='text-[#4B555C] font-[600]' style={{ fontSize: fontSize }}>{data?.subtitle}</div>
                    <div className='text-[#4B555C] font-[600] mt-[24px]' style={{ fontSize: fontSize }}><div dangerouslySetInnerHTML={{ __html: data?.description }}></div></div>
                    {['1', '3', '5', '7', '9', '11'].includes(group) && <div dangerouslySetInnerHTML={{ __html: groupADetails }}></div>}
                    {['2', '4', '6', '8', '10', '12'].includes(group) && <div dangerouslySetInnerHTML={{ __html: groupBDetails }}></div>}
                </div>
                <div className='w-full flex items-center justify-center'>
                    <button onClick={() => navigate(`/platform2/research-practices/${data?.id}/`)} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                        <div className='rounded-full px-[48px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                            進入
                        </div>
                    </button>
                </div>
            </div>

            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
